import { i18n } from './i18n.js';
import Cookie from 'js-cookie';

export default {

    // The install method will be called with the Vue constructor as the first argument, along with possible options
    install( app, options ) {
    // ES6 way of const job = options.job
        // const { job } = options

        app.config.globalProperties.$utils = {

            secretKey: 'Client Control Panel',

            timers: {
                counter: null,
                session: null,
            },
            fadeOutLoading() {
                let loading = document.getElementsByClassName( 'loading' );
                this.showLoading( loading ).then( ( loading )=>{
                    window.setTimeout( function() {
                        $( loading ).fadeOut();
                    }, 200 );
                } );
            },

            showLoading( loading ) {
                return new Promise( function( resolve, reject ) {
                    resolve( $( loading ).show() );
                } );
            },

            checkSideBar() {
                if ( Cookie.get( 'sidebar_toggle_state' ) && Cookie.get( 'sidebar_toggle_state' ) === 'on' ) {
                    document.getElementById( 'm_aside_left_minimize_toggle' ).classList.add( 'm-brand__toggler--active' );
                    document.body.classList.add( 'm-brand--minimize', 'm-aside-left--minimize' );
                }
            },

            cloneObject( obj ) {
                return JSON.parse( JSON.stringify( obj ) );
            },

            showPrice( property ) {
                if ( !property.Price ) {
                    return '';
                }

                let currencySign = '&euro;';

                if ( property.Currency === 'GBP' ) {
                    currencySign = '&pound;';
                }

                if ( !property.OfferType || property.OfferType.Id === 3 ) {
                    return this.formatNumber( property.Price, null, 0 ) + currencySign;
                }

                if ( property.OfferType.Id === 4 ) {
                    return this.formatNumber( property.Price, null, 0 ) + currencySign + ' / ' + i18n.global.t( 'common.month' );
                }

                if ( property.OfferType.Id === 2 ) {
                    if ( property.HighSeasonPrice && property.HighSeasonPrice > property.Price ) {
                        return this.formatNumber( property.Price, null, 0 ) + currencySign + ' - ' + this.formatNumber( property.HighSeasonPrice, null, 0 ) + currencySign +  ' / ' + i18n.global.t( 'common.week' );
                    }

                    return this.formatNumber( property.Price, null, 0 ) + currencySign + ' / ' + i18n.global.t( 'common.week' );
                }

                return '';
            },

            hideTopBarSideBar() {
                if ( document.body.classList.contains( 'm-topbar--on' ) ) {
                    document.body.classList.remove( 'm-topbar--on' );
                }

                if ( document.body.classList.contains( 'm-aside-left--on' ) ) {
                    document.body.classList.remove( 'm-aside-left--on' );
                    document.getElementById( 'm_aside_left' ).classList.remove( 'm-aside-left--on' );
                    document.getElementById( 'm_aside_left_offcanvas_toggle' ).classList.remove( 'm-brand__toggler--active' );
                    document.body.click();
                    mUtil.remove( document.querySelector( '.m-aside-left-overlay' ) );
                    // document.querySelector('.m-aside-left-overlay').remove();
                }
            },

            startScripts() {
                mApp.init( {} );
                TSModal.init();
                mLayout.init();
                mUtil.init( {} );
                this.hideTopBarSideBar();

                // Plugin global lazy initialization
                document.addEventListener( 'click', function( e ) {
                    let body = mUtil.get( 'body' );
                    let query = body.querySelectorAll( '.m-menu__nav .m-menu__item.m-menu__item--submenu.m-menu__item--hover:not(.m-menu__item--tabs)[m-menu-submenu-toggle="click"]' );
                    if ( query ) {
                        for ( let i = 0, len = query.length; i < len; i++ ) {
                            let element = query[ i ].closest( '.m-menu__nav' ).parentNode;

                            if ( element ) {
                                let the = mUtil.data( element ).get( 'menu' );

                                if ( !the ) {
                                    break;
                                }

                                if ( !the || the.getSubmenuMode() !== 'dropdown' ) {
                                    break;
                                }

                                if ( e.target !== element && element.contains( e.target ) === false ) {
                                    let items = element.querySelectorAll( '.m-menu__item--submenu.m-menu__item--hover:not(.m-menu__item--tabs)[m-menu-submenu-toggle="click"]' );
                                    if ( items ) {
                                        for ( let j = 0, cnt = items.length; j < cnt; j++ ) {
                                            the.hideDropdown( items[ j ] );
                                        }
                                    }
                                }
                            }
                        }
                    }
                }, { passive: true } );
            },
            refreshScripts() {
                TSModal.init();
                mLayout.init();
                this.hideTopBarSideBar();
                mApp.initScrollers();
                mApp.initPortlets();
                mApp.startCustomTabs();
            },

            formatCurrency( quantity, curr ) {
                let lang = Cookie.get( 'locale' ) === 'en' ? 'en-GB' : 'es-ES';

                if ( quantity === 0 ) {
                    return 0;
                }

                if ( !window.Intl ) {
                    return quantity;
                }

                if ( typeof curr !== 'undefined' ) {
                    return Intl.NumberFormat( lang, { style: 'currency',
                        currency: curr,
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0 } ).format( quantity );
                } else {
                    return Intl.NumberFormat( lang, { minimumFractionDigits: 0,
                        maximumFractionDigits: 0 } ).format( quantity );
                }
            },

            formatNumber( n, c, d, t ) {
                c = isNaN( c = Math.abs( c ) ) ? 2 : c;
                d = d === undefined ? '.' : d;
                t = t === undefined ? ',' : t;

                let s = n < 0 ? '-' : '';
                let i = String( parseInt( n = Math.abs( Number( n ) || 0 ).toFixed( c ) ) );
                let j = 0;

                j = ( j = i.length ) > 3 ? j % 3 : 0;

                return s + ( j ? i.substr( 0, j ) + t : '' ) + i.substr( j ).replace( /(\d{3})(?=\d)/g, '$1' + t ) + ( c ? d + Math.abs( n - i ).toFixed( c ).slice( 2 ) : '' );
            },

            getFilename( url ) {
                let urlpre = url.substring( url.lastIndexOf( '/' ) + 1 );
                return decodeURI( urlpre );
            },
        };
    },
};
